import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNewProduct } from '../../../../utils/calculator/calculateDate.util';
import { getOpenMarketProductPrice } from '../../../../utils/getter/getProductPrice.util';
import { IOpenMarketProduct } from '../../../../interfaces/Product.interfaces';
import { getOpenMarketDetailPageURL } from '../../../../utils/getter/getProductDetailPageURL.util';
import { getOpenMarketProductTitle } from '../../../../utils/getter/getOpenMarketProductTitle.util';
import { IProductForSummaryCard, ProductSummaryCard } from '../ProductSummaryCard/ProductSummaryCard';

interface OpenMarketProductListSummaryViewProps {
  product: IOpenMarketProduct;
}

export const OpenMarketProductListSummaryView = ({ product }: OpenMarketProductListSummaryViewProps) => {
  const navigate = useNavigate();

  const productDetailPageURL = useMemo<string>(() => {
    return getOpenMarketDetailPageURL(product.id);
  }, [product.id]);

  const isBlurred = useMemo<boolean>(() => {
    if (product.status === 'SOLDOUT' || product.status === 'IN_CONTRACT') {
      return true;
    }

    return false;
  }, [product.status]);

  const dimmedText = useMemo<string>(() => {
    if (product.status === 'SOLDOUT') {
      return '판매 완료';
    }

    if (product.status === 'IN_CONTRACT') {
      return '계약중';
    }

    return '';
  }, [product.status]);

  const canGoDetailPage = useMemo<boolean>(() => {
    if (product.status === 'ONSALE') {
      return true;
    }

    if (product.status === 'IN_CONTRACT') {
      return true;
    }

    return false;
  }, [product.status]);

  const price = useMemo<string>(() => {
    return getOpenMarketProductPrice(product.status, product.hopeSellingPrice);
  }, [product]);

  return (
    <ProductSummaryCard
      product={product as IProductForSummaryCard}
      handleClick={() => canGoDetailPage && navigate(productDetailPageURL)}
      blurEffect={{ isBlurred, dimmedText }}
      isNewProduct={isNewProduct(new Date(product.approvalDate), product.status)}
      price={price}
      title={getOpenMarketProductTitle(product)}
    />
  );
};
